export default function WhyFpcSection() {
  const rows = [
    { label: "State Dept Registered", fpc: ["✓ 20+ years", "bg-[#E8F0FE] text-[#1A365D] font-semibold"], fedex: "Partial (uses courier)", online: "Sometimes", diy: "N/A" },
    { label: "Direct Courier", fpc: ["✓ Yes", "bg-[#E8F0FE] text-[#1A365D] font-semibold"], fedex: "✗ Reseller", online: "✗ Reseller", diy: "N/A" },
    { label: "Reserved Agency Slots", fpc: ["✓ Daily", "bg-[#E8F0FE] text-[#1A365D] font-semibold"], fedex: "Through their courier", online: "Through their courier", diy: "✗ No" },
    { label: "Expert Doc Review", fpc: ["✓ Included", "bg-[#E8F0FE] text-[#1A365D] font-semibold"], fedex: "✗ Limited", online: "✗ Limited", diy: "✗ None" },
    { label: "Processing From", fpc: ["3 business days", "bg-[#E8F0FE] text-[#1A365D] font-semibold"], fedex: "3–5 business days", online: "3–7 business days", diy: "2–3 weeks" },
    { label: "Service Fee", fpc: ["From $195", "bg-[#E8F0FE] text-[#1A365D] font-semibold"], fedex: "$400–$700+", online: "$300–$600+", diy: "$60 govt only" },
    { label: "BBB Rating", fpc: ["A+", "bg-[#E8F0FE] text-[#1A365D] font-semibold"], fedex: "Varies", online: "Varies", diy: "N/A" },
    { label: "Physical Locations", fpc: ["24 nationwide", "bg-[#E8F0FE] text-[#1A365D] font-semibold"], fedex: "FedEx/Staples stores", online: "Online only", diy: "Post offices" },
  ];

  return (
    <section id="why-fpc" className="py-16 md:py-20 bg-[#F7F8FA]">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4 text-center">
          Why Choose Fast Passport Center
        </h2>
        <p className="text-gray-600 text-center max-w-2xl mx-auto mb-12 text-base md:text-lg">
          Direct comparison — see exactly how we stack up against retail counters, online resellers, and doing it yourself.
        </p>

        <div className="overflow-x-auto rounded-lg border border-[#D0D7E2] bg-white">
          <table className="w-full text-sm">
            <thead>
              <tr className="border-b border-[#D0D7E2]">
                <th className="text-left p-4 font-bold text-[#1A365D] bg-[#F0F4F8] w-1/5">Feature</th>
                <th className="text-left p-4 font-bold text-[#1A365D] bg-[#E8F0FE]">
                  <div className="flex items-center gap-2">
                    <i className="ri-shield-star-line text-[#4A7AB5]"></i> Fast Passport Center
                  </div>
                </th>
                <th className="text-left p-4 font-bold text-gray-600">FedEx/Staples</th>
                <th className="text-left p-4 font-bold text-gray-600">Online Reseller</th>
                <th className="text-left p-4 font-bold text-gray-600">DIY Govt</th>
              </tr>
            </thead>
            <tbody>
              {rows.map((row, i) => (
                <tr key={i} className="border-b border-[#F0F4F8] last:border-0 hover:bg-[#F7F8FA] transition-colors">
                  <td className="p-4 font-semibold text-[#1A365D]">{row.label}</td>
                  <td className={`p-4 ${row.fpc[1]}`}>{row.fpc[0]}</td>
                  <td className="p-4 text-gray-500">{row.fedex}</td>
                  <td className="p-4 text-gray-500">{row.online}</td>
                  <td className="p-4 text-gray-500">{row.diy}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <p className="text-center text-gray-500 text-xs mt-4">
          Government fees are separate for all options. FPC service fee covers document review, courier submission, and overnight return delivery.
        </p>
      </div>
    </section>
  );
}